import { useQuery } from '@tanstack/react-query';
import { inAppNotificationsGetMyUnreadInAppNotifications } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useUnreadInAppNotifications = () =>
  useQuery({
    queryKey: ['InAppNotifications', 'my', 'unread'],
    queryFn: () =>
      extractData(inAppNotificationsGetMyUnreadInAppNotifications()),
  });
